import React from "react";
import trash from "../../../../assets/img/admin/trash.svg";
import edit from "../../../../assets/img/admin/edit.svg";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import Button from "../../../shared/Button";
const AdminBlogCat = () => {
  return (
    <div className="AdminBlogCat">
      <h2 className="text-[36px] font-[700] text-[#12171C]">
        دسته بندی مقالات
      </h2>
      <div className="AdminBlogCat__container">
        <Swiper spaceBetween={32} slidesPerView={5}>
          <SwiperSlide>
            <div className="AdminBlogCat--paper flex justify-between">
              <div className="flex gap-[4px] items-center">
                <div className="px-[10px] py-[5px]  rounded-[6px] bg-[#00A6A6] text-[15px] w-max text-[#fff] font-[700]">
                  145
                </div>
                <h6 className="text-[18px] font-[500] text-[#BBBBBB]">
                  سفر کجا برم
                </h6>
              </div>
              <div className="flex  items-center">
                <button className="edit-icon">
                  <img src={edit} />
                </button>
                <button className="trash-icon">
                  <img src={trash} />
                </button>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="AdminBlogCat--paper flex justify-between">
              <div className="flex gap-[4px] items-center">
                <div className="px-[10px] py-[5px]  rounded-[6px] bg-[#00A6A6] text-[15px] w-max text-[#fff] font-[700]">
                  145
                </div>
                <h6 className="text-[18px] font-[500] text-[#BBBBBB]">
                  سفر کجا برم
                </h6>
              </div>
              <div className="flex  items-center">
                <button className="edit-icon">
                  <img src={edit} />
                </button>
                <button className="trash-icon">
                  <img src={trash} />
                </button>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="AdminBlogCat--paper flex justify-between">
              <div className="flex gap-[4px] items-center">
                <div className="px-[10px] py-[5px]  rounded-[6px] bg-[#00A6A6] text-[15px] w-max text-[#fff] font-[700]">
                  145
                </div>
                <h6 className="text-[18px] font-[500] text-[#BBBBBB]">
                  سفر کجا برم
                </h6>
              </div>
              <div className="flex  items-center">
                <button className="edit-icon">
                  <img src={edit} />
                </button>
                <button className="trash-icon">
                  <img src={trash} />
                </button>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="AdminBlogCat--paper flex justify-between">
              <div className="flex gap-[4px] items-center">
                <div className="px-[10px] py-[5px]  rounded-[6px] bg-[#00A6A6] text-[15px] w-max text-[#fff] font-[700]">
                  145
                </div>
                <h6 className="text-[18px] font-[500] text-[#BBBBBB]">
                  سفر کجا برم
                </h6>
              </div>
              <div className="flex  items-center">
                <button className="edit-icon">
                  <img src={edit} />
                </button>
                <button className="trash-icon">
                  <img src={trash} />
                </button>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="AdminBlogCat--paper flex justify-between">
              <div className="flex gap-[4px] items-center">
                <div className="px-[10px] py-[5px]  rounded-[6px] bg-[#00A6A6] text-[15px] w-max text-[#fff] font-[700]">
                  145
                </div>
                <h6 className="text-[18px] font-[500] text-[#BBBBBB]">
                  سفر کجا برم
                </h6>
              </div>
              <div className="flex  items-center">
                <button className="edit-icon">
                  <img src={edit} />
                </button>
                <button className="trash-icon">
                  <img src={trash} />
                </button>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="AdminBlogCat--paper flex justify-between">
              <div className="flex gap-[4px] items-center">
                <div className="px-[10px] py-[5px]  rounded-[6px] bg-[#00A6A6] text-[15px] w-max text-[#fff] font-[700]">
                  145
                </div>
                <h6 className="text-[18px] font-[500] text-[#BBBBBB]">
                  سفر کجا برم
                </h6>
              </div>
              <div className="flex  items-center">
                <button className="edit-icon">
                  <img src={edit} />
                </button>
                <button className="trash-icon">
                  <img src={trash} />
                </button>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="AdminBlogCat--paper flex justify-between">
              <div className="flex gap-[4px] items-center">
                <div className="px-[10px] py-[5px]  rounded-[6px] bg-[#00A6A6] text-[15px] w-max text-[#fff] font-[700]">
                  145
                </div>
                <h6 className="text-[18px] font-[500] text-[#BBBBBB]">
                  سفر کجا برم
                </h6>
              </div>
              <div className="flex  items-center">
                <button className="edit-icon">
                  <img src={edit} />
                </button>
                <button className="trash-icon">
                  <img src={trash} />
                </button>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default AdminBlogCat;
